import Control from '../../common/Control';
import includes from 'lodash/includes';
import { connect } from 'react-redux';
import { matrixBlur, matrixControlChange } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    checked: includes(question.rows[ownProps.rowIndex].values, ownProps.value),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(
      matrixControlChange(
        e.target.value,
        e.target.checked,
        ownProps.rowIndex,
        ownProps.questionId
      )
    ),
  onBlur: () => dispatch(matrixBlur(ownProps.rowIndex, ownProps.questionId)),
});

const MatrixControl = connect(mapStateToProps, mapDispatchToProps)(Control);

export default MatrixControl;
